export default __webpack_public_path__ + "static/media/tempStore1.f0f8038d.png";